import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/success-view.svg'


const _hoisted_1 = {
  class: "modal modal-md fade",
  id: "modal-sucessfully-sent",
  tabindex: "-1",
  "aria-labelledby": "modalSucessfullySent",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content modal-component" }
const _hoisted_4 = { class: "modal-footer" }
const _hoisted_5 = { class: "w-100 d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"modal-header header\" data-v-7463db77><div class=\"w-100 d-flex align-items-center justify-content-between\" data-v-7463db77><span class=\"fs-5 fw-semibold\" data-v-7463db77>Sucesso!</span><button class=\"btn-close\" id=\"btnCloseModal\" type=\"button\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-7463db77></button></div></div><div class=\"modal-body d-flex flex-column gap-3\" data-v-7463db77><div class=\"d-flex flex-column align-items-center\" data-v-7463db77><img class=\"success-image mb-4\" src=\"" + _imports_0 + "\" alt=\"success-view\" data-v-7463db77><span data-v-7463db77></span>Recebemos seus documentos com sucesso! Agora é só aguardar o retorno de um de nossos agentes.</div></div>", 2)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("button", {
              class: "btn btn-outline-primary",
              type: "button",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, "Enviar mais documentos", -1)),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirect && _ctx.redirect(...args))),
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, [
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "Sair", -1)),
              _createVNode(_component_Icon, {
                class: "ms-2",
                name: "right-from-bracket"
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}